import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import fetch from 'isomorphic-fetch';
import queryString from 'query-string-for-all';
var baseHost = window.location ? window.location.protocol + '//' + window.location.host : 'http://localhost:3000';
export var tapiBaseUrl = "".concat(baseHost, "/tapi/v1");
export var baseQuery = fetchBaseQuery({
    baseUrl: tapiBaseUrl,
    fetchFn: fetch
});
export var stringifyUrl = function(url, query) {
    return queryString.stringifyUrl({
        url: url,
        query: query
    }, {
        arrayFormat: 'bracket'
    });
};
